var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTeams = function SvgTeams(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    fillRule: "evenodd",
    d: "M10.567 7.2a2.6 2.6 0 1 0-2.4-1.6H1.9a.733.733 0 0 0-.733.733v7.334c0 .405.328.733.733.733h4.158a4.51 4.51 0 0 0 4.309 3.6 4.51 4.51 0 0 0 4.007-2.664c.36.17.762.264 1.187.264h.013a2.793 2.793 0 0 0 2.793-2.793V8.76a.76.76 0 0 0-.76-.76h-7.64v-.87q.29.07.6.07m7.4-1.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0M6.031 8.391h1.466v-.774h-3.86v.774h1.46v3.992h.934z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTeams);
export default ForwardRef;